import React, { Fragment, useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import Toast from "../../toast/SetToast";
import {
  notifyTopRight,
  notifyError,
} from "../../toast/SetToast";
import { useFirestore } from "../../../../hook/useFirestore";

import { TechEditForm } from "./TechEditForm";
import {
  buildTechnicianUpdatePayload,
  DEFAULT_TECHNICIAN_ROLES,
  normalizeTechnicianRoles,
} from "./techFormUtils";

const TechEdit = (props) => {
  const { updateDocument } = useFirestore("sleeptechnicians");
  const [checked, setChecked] = useState(DEFAULT_TECHNICIAN_ROLES);
  const inputRef = useRef({
    techId: "",
    name: "",
    fullname: "",
    email: "",
    tel: "",
    node: "",
    roles: [],
    certificate: "",
    status: "",
    accessToken: "",
    nickname: "",
    team: "",

    recordCashRate: "",
    recordSocialSecurityRate: "",
    scoreCashRate: "",
    scoreSocialSecurityRate: "",

    employmentType: "",

    guaranteeCase: "",
    splitNightTopupRate: "",

    homeFirstCaseRate: "",
    homeSecondCaseRate: "",
    overnightFirstCaseRate: "",
    overnightSecondCaseRate: "",
    RPHFullnightFirstCaseRate: "",
    RPHFullnightSecondCaseRate: "",
    RPHSplitNightFirstCaseRate: "",
    RPHSplitNightSecondCaseRate: "",
    note: "",
  });
  const changedFieldsRef = useRef({});

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
    changedFieldsRef.current[name] = true;
  };

  const handleChecked = (e, idx) => {
    if (e.target.checked) {
      let o = Object.assign({}, checked[idx], {
        ...checked[idx],
        status: true,
      });
      const updateList = [
        ...checked.slice(0, idx),
        o,
        ...checked.slice(idx + 1),
      ];

      setChecked(updateList);
    } else {
      let o = Object.assign({}, checked[idx], {
        ...checked[idx],
        status: false,
      });
      const updateList = [
        ...checked.slice(0, idx),
        o,
        ...checked.slice(idx + 1),
      ];

      setChecked(updateList);
    }
  };

  const handleOnHideModal = () => {
    props.hide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = buildTechnicianUpdatePayload({
      item: props.item,
      inputValues: inputRef.current,
      changedFields: changedFieldsRef.current,
      checkedRoles: checked,
      paymentAccess: props.paymentAccess === true,
    });

    try {
      const result = await updateDocument(props.item.id, formData);

      if (result) {
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
        props.hide();
        inputRef.current = {};
        changedFieldsRef.current = {};
      } else {
        notifyError("บันทึกข้อมูลผิดพลาด ");
      }
    } catch (err) {
      notifyError("บันทึกข้อมูลผิดพลาด ", err);
    }
  };

  useEffect(() => {
    setChecked(normalizeTechnicianRoles(props.item && props.item.roles));
    inputRef.current = {};
    changedFieldsRef.current = {};
  }, [props.item]);

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Edit Technician Datails</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TechEditForm
            onChange={handleChange}
            initailValues={props.item}
            onChecked={handleChecked}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>

          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default TechEdit;
